import { render } from "./ImportGradesDialog.vue?vue&type=template&id=6c7e7a62"
import script from "./js/importGradesDialog.js?vue&type=script&lang=js&external"
export * from "./js/importGradesDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__